import type { WAFChallengeDetector, WAFDetectableResponse, WAFProvider } from './types';

// Keyed by provider so a re-run of bootstrap (or HMR) replaces rather than duplicates a detector.
const registeredDetectors = new Map<WAFProvider, WAFChallengeDetector>();

export function registerWAFChallengeDetector(detector: WAFChallengeDetector): void {
  registeredDetectors.set(detector.provider, detector);
}

/** Origin-scoping is the caller's responsibility and must be applied before calling this. */
export function detectWAFProvider(response: WAFDetectableResponse): WAFProvider | null {
  for (const detector of registeredDetectors.values()) {
    try {
      if (detector.matches(response)) {
        return detector.provider;
      }
    } catch {
      // A broken detector must neither claim the response nor break the interceptor that calls this.
    }
  }
  return null;
}

export function TestOnlyResetWAFChallengeDetectors(): void {
  registeredDetectors.clear();
}
